import API_ENDPOINTS from '../constants/api_endpoints';
import { realBricksApi } from './api.service';

export const getFundingSourceService = (
    page,
    limit
) => {
    return realBricksApi.get(
        `${API_ENDPOINTS.FUNDINGSOURCE.GetFundingSources}?page=${page}&limit=${limit}`
    );
};

export const removeFundingSource = (
    sourceId
) => {
    return realBricksApi.delete(
        `${API_ENDPOINTS.FUNDINGSOURCE.deleteFundingSource}/${sourceId}`
    );
};
export const declineFundingSourceRequest = (
    sourceId
) => {
    return realBricksApi.put(
        `${API_ENDPOINTS.FUNDINGSOURCE.deleteFundingSourceRequest}/${sourceId}`
    )
};
export const getDeactivatedUsersService = (
    page,
    limit,
    searchTerm
) => {
    return realBricksApi.get(
        `${API_ENDPOINTS.FUNDINGSOURCE.GetDeactivatedUsersList}?page=${page}&limit=${limit}${searchTerm !== '' ? `&search=${searchTerm}` : ''}`
    );
};